import { styled } from '@mui/material/styles';
import { memo, useEffect, useState } from 'react';

const SnowContainer = styled('div')({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  pointerEvents: 'none',
  zIndex: 9999,
  overflow: 'hidden',
});

const Snowflake = styled('div')(({ delay, duration, left, size, drift }) => ({
  position: 'absolute',
  top: '-10px',
  left: `${left}%`,
  width: `${size}px`,
  height: `${size}px`,
  color: 'white',
  opacity: 0.8,
  animation: `fall ${duration}s linear ${delay}s infinite`,
  fontSize: `${size}px`,
  lineHeight: 1,
  '@keyframes fall': {
    '0%': {
      transform: 'translateY(0) translateX(0) rotate(0deg)',
      opacity: 0.8,
    },
    '100%': {
      transform: `translateY(100vh) translateX(${drift}px) rotate(360deg)`,
      opacity: 0,
    },
  },
}));

function SnowAnimation() {
  const [snowflakes, setSnowflakes] = useState([]);

  useEffect(() => {
    // Generate 50 snowflakes with random properties
    const flakes = Array.from({ length: 50 }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      size: Math.random() * 8 + 10, // 10-18px for better visibility
      duration: Math.random() * 5 + 5, // 5-10s
      delay: Math.random() * 5, // 0-5s
      drift: Math.random() * 100 - 50, // -50 to 50px horizontal drift
    }));
    setSnowflakes(flakes);
  }, []);

  return (
    <SnowContainer>
      {snowflakes.map((flake) => (
        <Snowflake
          key={flake.id}
          left={flake.left}
          size={flake.size}
          duration={flake.duration}
          delay={flake.delay}
          drift={flake.drift}
        >
          ❄
        </Snowflake>
      ))}
    </SnowContainer>
  );
}

export default memo(SnowAnimation);

